import { __decorate } from "tslib";
import { injectable } from 'inversify';
import psHttp, { RequestChannel } from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '@cores/constants/envConfig';
// 可以防止接口被连续多次调用
const initHiroBasicFetchChannel = new RequestChannel();
let HiroBasicApiImpl = class HiroBasicApiImpl {
    async getHiroBasic() {
        const response = await psHttp({
            url: `${coreSearchApiUrlPrefix}/chat/init`,
            method: 'GET',
            transformCode: true,
        });
        return response.data?.data;
    }
    async getSmartFilterInfos(req) {
        if (req.filter_ids.length === 0) {
            return {};
        }
        const result = await initHiroBasicFetchChannel.requestAsPromise({
            url: `${coreSearchApiUrlPrefix}/agent/filter-v2/${req.filter_ids.join(',')}`,
            method: 'GET',
            transformCode: true,
        });
        return result.data || {};
    }
};
HiroBasicApiImpl = __decorate([
    injectable()
], HiroBasicApiImpl);
export { HiroBasicApiImpl };
